import type { IconNode } from '../types';

/**
 * @name waffle
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgLz4KICA8cGF0aCBkPSJtNyAxNCA3LTciIC8+CiAgPHBhdGggZD0ibTEwIDE3IDctNyIgLz4KICA8cGF0aCBkPSJtNyAxMCA3IDciIC8+CiAgPHBhdGggZD0ibTEwIDcgNyA3IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/waffle
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const waffle: IconNode = [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'm7 14 7-7', key: 'hkwgvc' }],
  ['path', { d: 'm10 17 7-7', key: 'boozfh' }],
  ['path', { d: 'm7 10 7 7', key: 'l7mr5t' }],
  ['path', { d: 'm10 7 7 7', key: '3fxxlt' }],
];

export default waffle;
